const GlobalItemsPage = () => {
  return (
    <div>
      <p>GlobalItemsPage</p>
    </div>
  )
}
export default GlobalItemsPage
